module.exports = __webpack_public_path__ + "images/mic7f764ff0d45b5b218674f47edad600f6.svg";